import { TokenName } from '@mewssystems/design-tokens';
import { getToken } from '@optimus-web/common';
import { InteractionState, TokenConfig } from './types';

export const colorTokens: TokenConfig = {
    [InteractionState.Default]: {
        basic: {
            disabled: getToken(TokenName.TEXT_DISABLED),
            inherit: 'inherit',
            standalone: getToken(TokenName.TEXT_STATIC_PRIMARY),
            inline: getToken(TokenName.TEXT_STATIC_PRIMARY),
        },
        default: {
            disabled: getToken(TokenName.TEXT_DISABLED),
            inherit: 'inherit',
            standalone: getToken(TokenName.TEXT_INTERACTIVE_DEFAULT),
            inline: getToken(TokenName.TEXT_INTERACTIVE_DEFAULT),
        },
        inverse: {
            disabled: getToken(TokenName.TEXT_DISABLED),
            inherit: 'inherit',
            standalone: getToken(TokenName.TEXT_STATIC_INVERSE),
            inline: getToken(TokenName.TEXT_STATIC_INVERSE),
        },
    },
    [InteractionState.Hover]: {
        basic: {
            disabled: getToken(TokenName.TEXT_DISABLED),
            inherit: 'inherit',
            standalone: getToken(TokenName.TEXT_STATIC_TERTIARY),
            inline: getToken(TokenName.TEXT_STATIC_TERTIARY),
        },
        default: {
            disabled: getToken(TokenName.TEXT_DISABLED),
            inherit: 'inherit',
            standalone: getToken(TokenName.TEXT_INTERACTIVE_HOVER),
            inline: getToken(TokenName.TEXT_INTERACTIVE_HOVER),
        },
        inverse: {
            disabled: getToken(TokenName.TEXT_DISABLED),
            inherit: 'inherit',
            standalone: getToken(TokenName.TEXT_STATIC_INVERSE),
            inline: getToken(TokenName.TEXT_STATIC_INVERSE),
        },
    },
    [InteractionState.Active]: {
        basic: {
            disabled: getToken(TokenName.TEXT_DISABLED),
            inherit: 'inherit',
            standalone: getToken(TokenName.TEXT_STATIC_PRIMARY),
            inline: getToken(TokenName.TEXT_STATIC_PRIMARY),
        },
        default: {
            disabled: getToken(TokenName.TEXT_DISABLED),
            inherit: 'inherit',
            standalone: getToken(TokenName.TEXT_INTERACTIVE_ACTIVE),
            inline: getToken(TokenName.TEXT_INTERACTIVE_ACTIVE),
        },
        inverse: {
            disabled: getToken(TokenName.TEXT_DISABLED),
            inherit: 'inherit',
            standalone: getToken(TokenName.TEXT_STATIC_INVERSE),
            inline: getToken(TokenName.TEXT_STATIC_INVERSE),
        },
    },
};
